import styled, { keyframes } from "styled-components";
import { fadeIn, slideInDown } from "react-animations";

const fadeInAnimation = keyframes`${fadeIn}`;
const slideInDownAnimation = keyframes`${slideInDown}`;

export const ContactSectionContainer = styled.div`
  padding-top: 5%;
  background-color: ${(props) => (props.isDarkMode ? "#0a0a1a" : "#e4e4e4")};
  color: ${(props) => (props.isDarkMode ? "#fff" : "#000")};
  border-radius: 10px;
  margin: 20px 0;
  animation: 1s ${fadeInAnimation};
`;

export const FormContainer = styled.div`
  padding: 20px;
  background-color: ${(props) => (props.isDarkMode ? "#444" : "#fff")};
  border-radius: 10px;
  box-shadow: ${(props) =>
    props.isDarkMode ? "0 0 10px #000" : "0 0 10px #ccc"};
  animation: 1s ${slideInDownAnimation};
`;

export const FAQContainer = styled.div`
  padding: 20px;
  background-color: ${(props) => (props.isDarkMode ? "#333" : "#fff")};
  color: ${(props) => (props.isDarkMode ? "#fff" : "#000")};
  border-radius: 5px;
  max-width: 600px;
  margin: 20px auto 0;
`;

export const FAQItem = styled.div`
  margin-bottom: 15px;
  border-bottom: 1px solid ${(props) => (props.isDarkMode ? "#444" : "#ddd")};
  &:last-child {
    border-bottom: none;
  }
`;

export const QuestionHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 0;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  font-size: 1.5em;
  color: ${(props) => (props.isDarkMode ? "#ffcc00" : "#007bff")};
`;

export const Question = styled.h2`
  font-size: 1.25em;
  flex-grow: 1;
  margin: 0;
`;

export const AnswerContainer = styled.div`
  padding: 10px 0;
  animation: 0.5s ${fadeInAnimation};
`;

export const Answer = styled.p`
  font-size: 1em;
  margin: 0;
`;
